import { IEmployment, IInvoice } from 'types';
import { checkIfContractActive, checkWorkerContractSigningStatus, isContractRenewalAllowed } from './app';
import { checkIfContractIsEndingIn7Days, isDateInPast } from './dateTime';
import {
  isInvoicePaid,
  isInvoiceApproved,
  checkIfInvoiceDue,
  checkIfInvoiceOverdue,
  isInvoiceUnapproved,
  isOneOffPaymentInvoice,
  isInvoiceOpen,
  isInvoiceFailed,
  isInvoiceProcessing,
  isInvoiceVoidOrFailed,
} from './invoice';

export const getTheraContract = (contract: IEmployment) => {
  if (!contract) {
    return null;
  }
  const isActive = checkIfContractActive(contract?.terminationDetails?.endDate);
  const isSigned = checkWorkerContractSigningStatus(contract);
  const isEndingIn7Days = checkIfContractIsEndingIn7Days(contract?.terminationDetails?.endDate);
  const isContractEnding = Boolean(contract?.terminationDetails?.endDate);
  const isContractEnded = isDateInPast(contract?.terminationDetails?.endDate);
  const isRenewalAllowed = isContractRenewalAllowed(contract?.companyID);

  const transformedContract: IEmployment & {
    isActive: boolean;
    isSigned: boolean;
    isEndingIn7Days: boolean;
    isContractEnding: boolean;
    isContractEnded: boolean;
    isRenewalAllowed: boolean;
  } = {
    ...contract,
    isActive,
    isSigned,
    isEndingIn7Days,
    isContractEnding,
    isContractEnded,
    isRenewalAllowed,
  };

  return transformedContract;
};

export const getTheraInvoice = (invoice: IInvoice) => {
  const isPaid = isInvoicePaid(invoice);
  const isApproved = isInvoiceApproved(invoice);
  const isUnapproved = isInvoiceUnapproved(invoice);
  const isOnCycle = invoice.startDate !== null && invoice.endDate !== null;
  const isDue = checkIfInvoiceDue(invoice.paymentDueDate);
  const isDenied = invoice.approvalStatus === 'DENIED';
  const isOneOff = isOneOffPaymentInvoice(invoice);
  const isOpen = isInvoiceOpen(invoice);
  const isFailed = isInvoiceFailed(invoice);
  const isProcessing = isInvoiceProcessing(invoice);
  const isVoidOrFailed = isInvoiceVoidOrFailed(invoice);
  const isVoid = invoice.status === 'VOID';
  const isOverdue = isOpen && checkIfInvoiceOverdue(invoice.paymentDueDate);

  const transformedInvoice: IInvoice & {
    isPaid: boolean;
    isApproved: boolean;
    isUnapproved: boolean;
    isOnCycle: boolean;
    isDue: boolean;
    isOverdue: boolean;
    isDenied: boolean;
    isOneOff: boolean;
    isOpen: boolean;
    isFailed: boolean;
    isProcessing: boolean;
    isVoidOrFailed: boolean;
    isVoid: boolean;
  } = {
    ...invoice,
    isPaid,
    isApproved,
    isUnapproved,
    isOnCycle,
    isDue,
    isOverdue,
    isDenied,
    isOneOff,
    isOpen,
    isFailed,
    isProcessing,
    isVoidOrFailed,
    isVoid,
  };

  return transformedInvoice;
};
